"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outdated = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.Outdated = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "outdated", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M200 400C310.4 400 400 310.4 400 200C400 89.6 310.4 0 200 0C89.6 0 0 89.6 0 200C0 211 9 220 20 220C31 220 40 211 40 200C40 111.6 111.6 40 200 40C288.4 40 360 111.6 360 200C360 288.4 288.4 360 200 360C149.4 360 104.4 336.6 75.2 300L100 300C111 300 120 291 120 280C120 269 111 260 100 260L20 260C9 260 0 269 0 280L0 360C0 371 9 380 20 380C31 380 40 371 40 360L40 319C76.4 368 134.2 400 200 400zM220 80L180 80L180 120L220 120L220 80zM220 140L180 140L180 320L220 320L220 140z" : "M160 320C248.4 320 320 248.4 320 160C320 78.8 259.6 12 181.2 1.6C180.8 1.6 180.4 1.4 180 1.4C173.4 0.6 166.8 0 160 0C71.6 0 0 71.6 0 160C0 171 9 180 20 180C31 180 40 171 40 160C40 93.8 93.8 40 160 40C174.2 40 187.4 43 200 47.6L200 47.4C246.6 63.8 280 107.8 280 160C280 226.2 226.2 280 160 280C124.4 280 92.8 264.4 70.8 240L100 240C111 240 120 231 120 220C120 209 111 200 100 200L20 200C9 200 0 209 0 220L0 300C0 311 9 320 20 320C31 320 40 311 40 300L40 265.2C69.2 298.6 112 320 160 320zM180 80L140 80L140 120L180 120L180 80zM180 140L140 140L140 240L180 240L180 140z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.Outdated.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.Outdated.displayName = "Blueprint5.Icon.Outdated";
exports.default = exports.Outdated;
//# sourceMappingURL=outdated.js.map